// MIT © 2017 azu
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LogGroup = require("./LogGroup");

var _LogGroup2 = _interopRequireDefault(_LogGroup);

var _LogChunk = require("./LogChunk");

var _LogChunk2 = _interopRequireDefault(_LogChunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrintLogger = function () {
    /**
     * @param {Object|Console} logger
     */
    function PrintLogger(logger) {
        _classCallCheck(this, PrintLogger);

        this.logger = logger;
    }

    /**
     * @param {LogGroup} logGroup
     */


    PrintLogger.prototype.printLogGroup = function printLogGroup(logGroup) {
        var _this = this;

        var childrenLogGroup = logGroup.children.filter(function (logItem) {
            return logItem instanceof _LogGroup2.default;
        });
        var includesUseCaseName = childrenLogGroup.filter(function (logGroup) {
            return logGroup !== undefined;
        }).map(function (logGroup) {
            return logGroup.useCaseName;
        }).join(", ");
        var groupTitleSuffix = childrenLogGroup.length > 0 ? "(includes \"" + includesUseCaseName + "\")" : "";
        var isIncludedErrorChunk = this._includeErrorChunk(logGroup);
        // x or flag
        var groupMark = isIncludedErrorChunk ? "\u274C" : "\uD83D\uDD16";
        var groupTitle = groupMark + " " + logGroup.title + groupTitleSuffix;
        this.logger.groupCollapsed(groupTitle);
        logGroup.children.forEach(function (logItem) {
            if (logItem instanceof _LogGroup2.default) {
                _this.printLogGroup(logItem);
            } else {
                _this._outputChunk(logItem);
            }
        });
        if (logGroup.children.length > 1) {
            var takenTime = logGroup.children[logGroup.children.length - 1].timeStamp - logGroup.children[0].timeStamp;
            this.logger.log("Taken time: " + takenTime + "ms");
        }
        this.logger.groupEnd(groupTitle);
    };

    /**
     * @param {LogChunk} chunk
     * @private
     */


    PrintLogger.prototype._outputChunk = function _outputChunk(chunk) {
        var logs = Array.isArray(chunk.log) ? chunk.log : [chunk.log];
        this._outputToConsole(logs);
    };

    /**
     * output logs
     * @param {*[]} logs
     * @private
     */


    PrintLogger.prototype._outputToConsole = function _outputToConsole(logs) {
        if (this._includeErrorChunkLogs(logs)) {
            var _logger;

            (_logger = this.logger).error.apply(_logger, _toConsumableArray(logs));
        } else {
            var _logger2;

            (_logger2 = this.logger).log.apply(_logger2, _toConsumableArray(logs));
        }
    };

    /**
     * Is include Error chunk
     * @param {LogGroup} logGroup
     * @returns {boolean}
     * @private
     */


    PrintLogger.prototype._includeErrorChunk = function _includeErrorChunk(logGroup) {
        var _this2 = this;

        return logGroup.children.some(function (chunk) {
            if (chunk instanceof _LogGroup2.default) {
                return _this2._includeErrorChunk(chunk);
            } else {
                return _this2._includeErrorChunkLogs(chunk.log);
            }
        });
    };

    /**
     * Is log Error instance
     * @param {*|*[]} logs
     * @private
     */


    PrintLogger.prototype._includeErrorChunkLogs = function _includeErrorChunkLogs(logs) {
        if (!Array.isArray(logs)) {
            return logs instanceof Error;
        }
        return logs.some(function (log) {
            return log instanceof Error;
        });
    };

    return PrintLogger;
}();

exports.default = PrintLogger;
module.exports = exports["default"];
//# sourceMappingURL=PrintLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-logger/lib/log/PrintLogger.js
// module id = 231
// module chunks = 0